const ROUTES = {
  USERS: "/api/users",
  AUTH: "/api/auth",
  OMDB: "/api/series",
};

export default ROUTES;
